// extracted by mini-css-extract-plugin
module.exports = {"loader":"CircularSpinner_loader__2QMkK","load8":"CircularSpinner_load8__33z2l"};